const BaseSelector = ({
    label, name, required, value, option, isTouch,  isValid, message, onChange, onBlur, placeholder, side
}) => {
    return(
        <div className={`select ${isTouch && !isValid ? "negative" : ""}`}>
            <label>
                {label}
                {required &&
                    <span className="required" aria-hidden="true">*</span>
                }
            </label>
            <div className="select-wrap">
                <div className="select-box">
                    <select
                        className="select-inner"
                        required={required}
                        name={name}
                        value={value ?? ""}
                        onChange={onChange}
                        onBlur={onBlur}
                    >
                        <option value="" disabled hidden>{placeholder}</option>
                        {option.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.text}
                            </option>
                        ))}
                    </select>
                </div>
                {side && <>{side}</>}
                {!isValid &&
                <div className="message-box">
                    <span className="message">{message}</span>
                </div>
                }
            </div>
        </div>
    )
}


export default BaseSelector;